import { useState } from 'react';
import { Button, Modal } from '@/components/UI';

interface PromptModalButtonProps {
    title: string;
    prompt: string;
}

const PromptModalButton = ({ title, prompt }: PromptModalButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button size="sm" variant="secondary" onClick={() => setOpen(true)}>
                View Prompt
            </Button>
            <Modal draggable={false} isOpen={open} size="xl" title={title} onClose={() => setOpen(false)}>
                <textarea
                    readOnly
                    className="h-[60vh] w-full resize-y rounded border border-zinc-800 bg-zinc-950 p-3 font-mono text-xs text-zinc-200"
                    value={prompt}
                />
            </Modal>
        </>
    );
};

export default PromptModalButton;
